import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { CascadeOption } from './CascadeSelect';
import { judgeMouseDirection } from '@/utils/common-utils';
import styles from './CascadeSelect.module.scss';

export const CascadeSelectOptions = (props: {
  options: CascadeOption[];
  isParentRef: boolean;
  handleSelect: (option: CascadeOption, event: MouseEvent) => void;
  id?: string;
  parentId?: string;
  dropdownMenuRef?: React.RefObject<HTMLUListElement>;
  isHalfWidth?: boolean;
  className?: string;
  pageUniqueId?: string;
}) => {
  const {
    options,
    isParentRef,
    handleSelect,
    isHalfWidth = false,
    dropdownMenuRef,
    className = '',
    id = '',
    parentId = '',
    pageUniqueId = '',
  } = props;
  const idUniqueId = id + pageUniqueId;
  const parentUniqueId = parentId + pageUniqueId;

  return (
    <Box
      className={`${styles.dropdownMenu} ${
        isHalfWidth ? (isParentRef ? 'w-1/2' : 'w-full') : ''
      } ${isParentRef ? 'mt-1' : ''} pb-2 text-sm text-black ${className}`}
      ref={dropdownMenuRef}
      id={idUniqueId}
      onMouseEnter={() =>
        !isParentRef &&
        parentUniqueId &&
        document
          .getElementById(parentUniqueId)
          ?.classList.add(styles.dropdownMenuOptionHover)
      }
      onMouseLeave={() => {
        if (!isParentRef && parentUniqueId && idUniqueId) {
          document
            .getElementById(parentUniqueId)
            ?.classList.remove(styles.dropdownMenuOptionHover);

          document
            .getElementById(idUniqueId)
            ?.classList.remove(styles.dropdownMenuShow);
        }
      }}
    >
      <List
        className="bg-slate-50 h-[400px] overflow-auto p-0"
        sx={{
          boxShadow: `${
            isParentRef ? '-5px' : '5px'
          } 5px 10px rgba(0, 0, 0, 0.04)`,
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {options.map((option, index) => {
          const { children, disabled, name, id } = option;
          const idUniqueId = id + pageUniqueId;
          if (Array.isArray(children) && children.length >= 1) {
            return (
              <li
                id={idUniqueId + index}
                className={`${styles.dropdownMenuOption} ${
                  styles.withSubOption
                } ${disabled ? styles.disabled : ''}`}
                key={`${index}-${id}`}
                onMouseDown={(e) => isParentRef && e.preventDefault()}
                onMouseEnter={() => {
                  if (isParentRef && id) {
                    options.map((item) => {
                      const oId = item.id + pageUniqueId;
                      if (idUniqueId !== oId) {
                        document
                          .getElementById(oId)
                          ?.classList.remove(styles.dropdownMenuShow);
                      } else {
                        document
                          .getElementById(idUniqueId)
                          ?.classList.add(styles.dropdownMenuShow);
                      }
                    });
                  }
                }}
                onMouseLeave={(e) => {
                  const direction = judgeMouseDirection(e);
                  if (direction !== 1) {
                    if (isParentRef && id) {
                      document
                        .getElementById(idUniqueId)
                        ?.classList.remove(styles.dropdownMenuShow);
                    }
                  }
                }}
              >
                {name}
              </li>
            );
          }
          return (
            <li
              aria-hidden
              className={`${styles.dropdownMenuOption} ${
                disabled ? styles.disabled : ''
              } w-full`}
              key={`${index}-${id}`}
              onMouseDown={(event: any) => handleSelect(option, event)}
              onTouchEnd={(event: any) => {
                handleSelect(option, event);
                event.preventDefault();
              }}
            >
              {name}
            </li>
          );
        })}
      </List>
      {options.map((option, index) => {
        const { children, id } = option;
        const idUniqueId = id + pageUniqueId;
        if (Array.isArray(children) && children.length >= 1) {
          return (
            <CascadeSelectOptions
              key={`${index}-${id}`}
              options={children}
              isParentRef={false}
              handleSelect={handleSelect}
              isHalfWidth={isHalfWidth}
              id={idUniqueId}
              parentId={idUniqueId + index}
            />
          );
        }
        return null;
      })}
    </Box>
  );
};

export default CascadeSelectOptions;
